module.exports = __webpack_public_path__ + "img/male.4252d7de.svg";